import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';
import { overrideConsoleInProduction } from '@app/core/utils/console-override';

// Override console methods in production before any other code runs
overrideConsoleInProduction();

if (environment.production && environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    tracesSampleRate: environment.sentry.rate,
    ignoreErrors: ['Non-Error exception captured', 'ChunkLoadError'],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.01,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
